import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { SortOption } from './sort-option.model';

export class ProductsSortedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.ProductsSorted;

  constructor(private sortOption: SortOption) {

  }

  getPayload(): any {
    return {
      sortOption: this.sortOption
    };
  }
}
